import { SidebarNavigationItem, SidebarNavigationSection } from './types';
import { ROUTE, ROUTE_STUDIO } from 'src/common/constants';

const SOFTWARE_MANUAL = 'Software Manual';
const FAQ = `F.A.Q's`;
const RULES = 'Rules';
const ADULT_RATINGS = 'Adult Ratings';
const CONTACT_US = 'Contact Us';
const OFFICIAL_STUFF = 'Official stuff';
const TERMS_AND_CONDITIONS = 'Terms & Conditions';
const PRIVACY_POLICY = 'Privacy Policy';
const EVENTS = 'Special Events';

export const sidebarNavigationRegistrationWizard: SidebarNavigationItem = {
    id: 3,
    name: 'Registration Wizard',
    path: ROUTE.WIZARD_REG,
    isNative: null,
};
export const sidebarNavigationRegisterStudio: SidebarNavigationItem = {
    id: 2,
    name: 'Register a Studio',
    path: ROUTE.REGISTRATION,
    isNative: true,
};

export const sidebarNavigationSectionStudioLogon: SidebarNavigationSection = {
    id: 11,
    category: 'Studio',
    items: [{ id: 1, name: 'Logon', path: ROUTE_STUDIO.LOGON, title: 'Studio Logon', isNative: true }],
};

export const sidebarNavigationItemProfile: SidebarNavigationItem = {
    id: 1,
    name: 'View My Profile',
    path: '/',
    title: 'View Profile',
    isNative: true,
    target: '_blank',
};
export const sidebarNavigationItemInbox: SidebarNavigationItem = {
    id: 1,
    name: 'Inbox',
    path: ROUTE.MAIL_LIST,
    title: 'Your Inbox',
    isNative: true,
    testId: 'ccmail-sidebar-chathost',
};
export const sidebarNavigationChangePassword: SidebarNavigationItem = {
    id: 6,
    name: 'Change password',
    path: '/chathost/changepassword.html',
    isNative: true,
};

export const studioSidebarNavigationSectionLoggedIn: SidebarNavigationSection[] = [
    {
        id: 1,
        category: 'Go To...',
        items: [{ id: 1, name: 'Chathost LogOn', path: ROUTE.LOGON, isNative: true }],
    },
    {
        id: 2,
        category: 'Studio...',
        items: [
            { id: 1, name: 'Resources', path: ROUTE_STUDIO.HOMEPAGE, isNative: null },
            { id: 2, name: 'Administration', path: ROUTE_STUDIO.MANAGEMENT, isNative: true },
            { id: 3, name: 'Payment Details', path: ROUTE_STUDIO.PAYMENT_DETAILS_UPDATE, isNative: true },
            { id: 4, name: 'Admin Password', path: ROUTE_STUDIO.PASSWORD_ADMIN, isNative: true },
            { id: 5, name: 'Owner Password', path: ROUTE_STUDIO.PASSWORD_OWNER, isNative: true },
            { id: 6, name: 'LogOff', path: ROUTE_STUDIO.LOGOFF, isNative: true },
        ],
    },
    {
        id: 8,
        category: 'Help',
        items: [
            { id: 1, name: SOFTWARE_MANUAL, path: ROUTE_STUDIO.VIDEO_HELP, isNative: null },
            { id: 2, name: FAQ, path: ROUTE_STUDIO.FAQ, isNative: null },
            { id: 3, name: ADULT_RATINGS, path: ROUTE_STUDIO.ADULT_RATINGS, isNative: null },
            { id: 4, name: CONTACT_US, path: ROUTE_STUDIO.CONTACT_US, isNative: null },
        ],
    },
    {
        id: 9,
        category: OFFICIAL_STUFF,
        items: [
            { id: 1, name: RULES, path: ROUTE_STUDIO.RULES, isNative: null },
            { id: 2, name: TERMS_AND_CONDITIONS, path: ROUTE_STUDIO.TERMS_AND_CONDITIONS, isNative: null },
            { id: 3, name: PRIVACY_POLICY, path: ROUTE_STUDIO.PRIVACY_POLICY, isNative: null },
        ],
    },
    {
        id: 10,
        category: 'Other',
        items: [{ id: 1, name: EVENTS, path: ROUTE_STUDIO.EVENTS, isNative: null }],
    },
];

export const sidebarNavigationSectionLoggedInGoto: SidebarNavigationSection = {
    id: 1,
    category: 'Go To...',
    items: [
        { id: 1, name: 'Chathost Resources', path: ROUTE.HOMEPAGE, isNative: null },
        { id: 2, name: 'LogOff', path: ROUTE.LOGOFF, title: 'Chathost LogOff', isNative: true },
    ],
};

export const sidebarNavigationSectionMaintenance: SidebarNavigationSection = {
    id: 3,
    category: 'Maintenance',
    items: [
        // Prettier ignore
        sidebarNavigationItemProfile,
        { id: 2, name: 'Edit My Profile', path: '/chathost/editprofile.html', title: 'Edit Profile', isNative: true },
        { id: 3, name: 'Media Archive', path: '/chathost/mediaarchive.html', isNative: true },
        { id: 4, name: 'Privacy Options', path: '/chathost/privacyctrl.html', isNative: true },
        { id: 5, name: 'E-mail Subscriptions', path: '/chathost/subscriptions.html', isNative: true },
    ],
};

export const sidebarNavigationSectionVideoSession: SidebarNavigationSection = {
    id: 2,
    category: 'Video Session',
    items: [
        { id: 1, name: 'Start Session', path: '/chathost/sessionstart.html', isNative: true },
        { id: 2, name: 'View Chat', path: '/chathost/currentsession.html', title: 'Connect to current session', isNative: true },
        { id: 3, name: 'End Session', path: '/chathost/sessionclose.html', title: 'Close current session', isNative: true },
    ],
};
export const sidebarNavigationItemsLoggedIn: SidebarNavigationSection[] = [
    {
        id: 4,
        category: 'ccMail',
        items: [
            // Prettier ignore
            sidebarNavigationItemInbox,
            { id: 2, name: 'ccMail Home Page', path: ROUTE.MAIL_CONTROL, isNative: null },
            { id: 3, name: 'Compose', path: ROUTE.MAIL_COMPOSE, isNative: true, testId: 'compose-sidebar-chathost' },
            { id: 4, name: 'Help', path: ROUTE.MAIL_FAQ, title: 'F.A.Q.', isNative: null },
        ],
    },
    {
        id: 5,
        category: 'Revenue',
        items: [{ id: 1, name: 'Revenue Details', path: ROUTE.REVENUE_DETAILS, isNative: null }],
    },
    {
        id: 6,
        category: 'Marketing',
        items: [
            { id: 1, name: 'Viewer Notes', path: '/chathost/viewershistory.html', isNative: true },
            { id: 2, name: 'Viewer Ratings', path: ROUTE.VIEWER_RATINGS, isNative: null },
            { id: 3, name: 'Revenue Ideas', path: `${ROUTE.FAQ}?qId=81`, isNative: null },
        ],
    },
    {
        id: 7,
        category: 'Forums & Chat',
        items: [
            { id: 1, name: 'Chathosts Forum', path: '/forum4.html', isNative: true, frameTarget: 'Content' },
            { id: 3, name: 'Community Chat', path: '/chathost/communitychat.html', isNative: true },
            { id: 4, name: 'Public Reviews', path: '/chathost/publicreviews.html', isNative: true },
        ],
    },
    {
        id: 8,
        category: 'Help',
        items: [
            { id: 1, name: SOFTWARE_MANUAL, path: ROUTE.VIDEO_HELP, isNative: null },
            { id: 2, name: FAQ, path: ROUTE.FAQ, isNative: null },
            { id: 3, name: ADULT_RATINGS, path: ROUTE.ADULT_RATINGS, isNative: null },
            { id: 4, name: CONTACT_US, path: ROUTE.CONTACT_US, isNative: null },
        ],
    },
    {
        id: 9,
        category: OFFICIAL_STUFF,
        items: [
            { id: 1, name: RULES, path: ROUTE.RULES, isNative: null },
            { id: 2, name: TERMS_AND_CONDITIONS, path: ROUTE.TERMS_AND_CONDITIONS, isNative: null },
            { id: 3, name: PRIVACY_POLICY, path: ROUTE.PRIVACY_POLICY, isNative: null },
            { id: 4, name: 'My Agreements', path: ROUTE.MY_AGREEMENTS, isNative: null },
        ],
    },
    {
        id: 10,
        category: 'Other',
        items: [{ id: 1, name: EVENTS, path: ROUTE.EVENTS, isNative: null }],
    },
];

export const sidebarNavigationPromoLink: SidebarNavigationItem = {
    id: 3,
    name: 'Event Details',
    path: '',
    isNative: null,
    isNew: true,
    frameTarget: '_top',
};
